import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TrendingUp, FileText } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtBRL = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

// Ranking dos 5 maiores devedores (fiado) para o gerente agir rápido.
export const TopDebtorsWidget = ({ colors, isLight, onOpenStatement }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/accounts/receivables/top-debtors?limit=5`, { withCredentials: true })
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  const maxBal = items.length ? Math.max(...items.map((i) => i.balance || 0)) : 0;

  return (
    <div className="rounded-md p-5" style={{ background: colors.card, border: `1px solid ${colors.border}` }} data-testid="top-debtors-widget">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-amber-400">Venda a Prazo</p>
          <h3 className="text-lg font-bold mt-0.5" style={{ color: isLight ? '#0F172A' : '#FFFFFF' }}>Top 5 Devedores</h3>
        </div>
        <div className="p-2 rounded" style={{ background: 'rgba(251, 191, 36, 0.15)' }}>
          <TrendingUp size={18} className="text-amber-400" />
        </div>
      </div>

      {loading ? (
        <p className="text-xs py-4 text-center" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>Carregando...</p>
      ) : items.length === 0 ? (
        <p className="text-xs py-4 text-center text-emerald-500 font-medium" data-testid="top-debtors-empty">✓ Nenhum cliente com saldo devedor</p>
      ) : (
        <ol className="space-y-2.5" data-testid="top-debtors-list">
          {items.map((it, i) => (
            <li key={it.id || i} className="flex items-center gap-3" data-testid={`top-debtor-${it.id}`}>
              <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-black" style={{ background: i === 0 ? '#FBBF24' : (isLight ? '#E2E8F0' : '#334155'), color: i === 0 ? '#78350F' : (isLight ? '#334155' : '#CBD5E1') }}>{i + 1}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-medium truncate" style={{ color: isLight ? '#0F172A' : '#F1F5F9' }}>{it.name}</p>
                  {it.credit_blocked && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-red-500/20 text-red-400">SEM FIADO</span>}
                </div>
                <div className="h-1.5 rounded-full mt-1 overflow-hidden" style={{ background: isLight ? '#F1F5F9' : '#1E293B' }}>
                  <div className="h-full rounded-full" style={{ width: `${maxBal ? Math.max(8, (it.balance / maxBal) * 100) : 0}%`, background: i === 0 ? '#F59E0B' : '#FB923C' }} />
                </div>
              </div>
              <span className="text-sm font-bold text-amber-500 font-mono shrink-0">{fmtBRL(it.balance)}</span>
              {it.id && onOpenStatement && (
                <button onClick={() => onOpenStatement(it.id)} className="shrink-0 p-1.5 rounded hover:bg-blue-500/20 text-blue-400" title="Ver extrato" data-testid={`top-debtor-statement-${it.id}`}>
                  <FileText size={15} />
                </button>
              )}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
